import { IconButton, Input, Modal } from '@ixyberfree/ixybercomponents';
import { ReadProcessed } from 'components/hmilib/api';
import { Items } from 'components/hmilib/hmiclientbase';
import { IDataHistory } from 'components/hmilib/hmiclientsdata';
import Search, { IComboBoxData } from 'components/MainControl/Settings/components/Search/Search';
import { IRefs } from 'components/MainPage/dcs/centumvp/components/Trends/components/Graph/Graph';
import LoadPage from 'components/MainPage/LoadPage';
import React, { useEffect, useState } from 'react';
import * as hmiclientbase from '../../../hmilib/hmiclientbase';
import * as hmiclientbasedata from '../../../hmilib/hmiclientbase';
import * as hmiclientsdata from '../../../hmilib/hmiclientsdata';
import ComboBox from './ComboBox/ComboBox';
import GroupGraph from './GroupGraph/GroupGraph';
import GroupTable from './GroupTable/GroupTable';
import styles from './index.module.css';

const IconLeft = (
    <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.65819 0.663018L4.45446 4.94029C4.17705 5.22275 4.17705 5.67815 4.45446 5.96349L8.65536 10.2408C8.79407 10.382 8.97524 10.4512 9.15641 10.4512C9.33758 10.4512 9.51875 10.382 9.65746 10.2408C9.93488 9.95831 9.93488 9.50291 9.65746 9.22045L5.95478 5.45045L9.66029 1.68334C9.93771 1.40088 9.93771 0.945479 9.66029 0.663018C9.38287 0.380557 8.93561 0.380556 8.65819 0.663018Z"
            fill="#AEAEAE"
        />
        <path
            d="M4.40908 0.663018L0.208185 4.94029C-0.0692323 5.22275 -0.0692323 5.67815 0.208185 5.96349L4.40908 10.2408C4.54779 10.382 4.72896 10.4512 4.91013 10.4512C5.0913 10.4512 5.27247 10.382 5.41118 10.2408C5.6886 9.95831 5.6886 9.50291 5.41118 9.22045L1.70851 5.45045L5.41118 1.68334C5.6886 1.40088 5.6886 0.945479 5.41118 0.663018C5.13376 0.380557 4.6865 0.380556 4.40908 0.663018Z"
            fill="#AEAEAE"
        />
    </svg>
);

const IconRight = (
    <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.34205 0.663018L5.54578 4.94029C5.8232 5.22275 5.8232 5.67815 5.54578 5.96349L1.34489 10.2408C1.20618 10.382 1.02501 10.4512 0.843836 10.4512C0.662665 10.4512 0.481495 10.382 0.342786 10.2408C0.0653677 9.95831 0.0653677 9.50291 0.342786 9.22045L4.04546 5.45045L0.339954 1.68334C0.0625372 1.40088 0.0625362 0.945479 0.339953 0.663018C0.617372 0.380557 1.06464 0.380556 1.34205 0.663018Z"
            fill="#AEAEAE"
        />
        <path
            d="M5.59116 0.663018L9.79206 4.94029C10.0695 5.22275 10.0695 5.67815 9.79206 5.96349L5.59116 10.2408C5.45246 10.382 5.27128 10.4512 5.09011 10.4512C4.90894 10.4512 4.72777 10.382 4.58906 10.2408C4.31165 9.95831 4.31165 9.50291 4.58906 9.22045L8.29174 5.45045L4.58906 1.68334C4.31165 1.40088 4.31165 0.945479 4.58906 0.663018C4.86648 0.380557 5.31375 0.380556 5.59116 0.663018Z"
            fill="#AEAEAE"
        />
    </svg>
);

export interface IPens {
    id: number;
    selected?: boolean;
    enable: boolean;
    name: string;
    curvalue?: string;
    desc?: string;
    eudesc?: string;
    min?: any;
    max?: any;
    color: string;
    typeLine: string | 'line' | 'linePoint' | 'point' | 'step' | 'areadiscrete' | 'radar';
    typeScale: string | 'auto' | 'system' | 'custom';
    yAxisIndex: number | undefined;
    markArea?: any[];
}

export interface IAxisSetting {
    type: string;
    min?: string;
    max?: string;
    delta?: string;
    name?: string;
}

export interface SearchData extends IComboBoxData {
    item?: any;
}

interface Iconfigplugin {
    id: string | undefined;
    config: any;
}
function index(props: Iconfigplugin) {
    const { config } = props;

    const [archive, setArchive] = React.useState({});
    const [penEdit, setPenEdit] = React.useState(-1);
    const [isEditingDesc, setIsEditingDesc] = useState(false);
    const [HmiHistorySettings, setHmiHistorySettings] = React.useState<IPens[] | undefined>(undefined);
    const [resetData, setResetData] = useState<boolean>(false);
    const [archiveTrend, setArchiveTrend] = React.useState(false);
    const coloritem = ['#00CCFF', '#967474', '#00cc00', '#ffcc00', '#ff00ff', '#ff0000', '#0000ff', '#8400ff'];
    const [selectedPen, setSelectedPen] = React.useState<string>('');
    //массив обьектов
    const [BlockGroups, setBlockGroups] = useState<string[]>([]);
    //данные для поиска
    const [comboBoxData, setComboBoxData] = useState<SearchData[]>([]);
    const [currentBlockGroup, setCurrentBlockGroup] = useState<string>(
        `${config.settings.chart.Block}/${config.settings.chart.Group}`
    );
    const [visibleTrendGroup, setVisibleTrendGroup] = useState<boolean>(true);

    const [xStart, setXStart] = React.useState(new Date().toISOString());

    const [PenEditElement, setPenEditElement] = useState({
        TAG: '',
        PARAM: '',
        DATA: ''
    });
    const refs: IRefs = {
        chartRef: React.useRef<any>(null),
        scrollRefX: React.useRef<HTMLDivElement>(null),
        scrollRefY: React.useRef<HTMLDivElement>(null)
    };

    const trendTime: { recordTime: any; samplingPeriod: any } = { recordTime: '', samplingPeriod: '' };
    const [trendInfo, setTrendInfo] = useState<any>({
        description: '',
        recordTime: 2,
        blockObj: {}
    });
    let pens: any[] = [];
    const [trendsPath, setTrendsPath] = useState<string>('');

    const fetchObjectByPath = async (path: string): Promise<any> => {
        try {
            const response = await fetch(`${window.hostdata}/Base/GetObject?path=${path}`);
            return await response.json();
        } catch (error) {
            console.error(`Ошибка при загрузке данных с пути: ${path}`);
            throw error;
        }
    };

    React.useEffect(() => {
        pens = [];

        const Path = `${config.settings.chart.Path}/TRENDS`;
        setTrendsPath(Path);

        if (Path) {
            fetchObjectByPath(Path)
                .then((res: any) => {
                    getPens(res).then((pensData) => {
                        pens = pensData;
                        let pensNames: string[] = [];
                        pens.forEach((pen) => {
                            pen.name ? pensNames.push(`${pen.DATA}/${pen.name}`) : pensNames.push('');
                        });
                        if (pens.length != 0) {
                            UpdateArchiveItems(pensNames);
                        }
                    });
                })
                .catch((error) => {
                    console.error('Блок TRENDS отсутствует', error);
                });
        }
    }, [config, resetData, currentBlockGroup, xStart, trendInfo.recordTime]);

    useEffect(() => {
        const Path = `${config.settings.chart.Path}/TRENDS`;

        fetchObjectByPath(Path)
            .then((res: any) => {
                const blocks = getBlockGroups(res);
                setBlockGroups(blocks);
            })
            .catch((error) => {
                console.error('Ошибка загрузки данных', error);
            });
    }, [config, resetData]);

    const getBlockGroups = (obj: any): any[] => {
        const arrayGroups = Object.values(obj.blocks || {}).flatMap((block: any) => Object.values(block.blocks || []));
        const arrayGroupForSearch: SearchData[] = arrayGroups.map((item: any, i: number) => {
            return { value: item.name, id: i.toString(), item: item };
        });

        setComboBoxData(arrayGroupForSearch);
        return arrayGroups;
    };

    const isEmpty = (obj: any) => {
        for (let key in obj) {
            return false;
        }
        return true;
    };

    async function getPens(obj: any): Promise<any[]> {
        let pens: any[] = [];
        for (let mKey in obj.blocks) {
            if (isEmpty(obj.blocks[mKey].blocks)) {
                const { Block, Group } = GetBlockGroup(currentBlockGroup);
                const BlockGroup = `${Block}/${Group}`;

                if (obj.path.includes(BlockGroup)) {
                    const block = obj.path.split('/').slice(0, -1).join('/');
                    let blockObj = Items[block];

                    await hmiclientbase.SettingsGetObjectDto(blockObj.id).then((data: any) => {
                        blockObj = data;
                        // setResetData(!resetData);
                    });

                    trendTime.recordTime = blockObj.parameters.RECORDTIME.CV;
                    trendTime.samplingPeriod = blockObj.parameters.SAMPLINGPERIOD.CV * 1000;

                    setTrendInfo({
                        ...obj,
                        description: obj.description,
                        recordTime: +blockObj.parameters.RECORDTIME.CV,
                        blockObj: blockObj
                    });

                    pens = await SaveGroupPens(obj);

                    return pens;
                }
            } else {
                const res = await getPens(obj.blocks[mKey]);
                if (res.length != 0) {
                    return res;
                } else {
                    getPens(obj.blocks[mKey]);
                }
            }
        }
        return pens;
    }

    // function extractPaths(obj: any, result: string[] = []) {
    //     for (let key in obj) {
    //         if (obj.hasOwnProperty(key)) {
    //             if (key === 'blocks' && typeof obj[key] === 'object') {
    //                 for (let block in obj[key]) {
    //                     if (obj[key].hasOwnProperty(block)) {
    //                         let blockObj = obj[key][block];
    //                         if (blockObj.path && /\/GROUP\d+$/.test(blockObj.path)) {
    //                             result.push(blockObj.path);
    //                         }
    //                         extractPaths(blockObj, result);
    //                     }
    //                 }
    //             } else if (typeof obj[key] === 'object') {
    //                 extractPaths(obj[key], result);
    //             }
    //         }
    //     }
    //     return result;
    // }

    const GetDate = (datelong: any) => {
        if (typeof datelong == 'number') {
            return window.ConvertDateNsToISO(datelong);
        } else {
            return new Date(datelong);
        }
    };

    async function getMinMax_markArea(data: IDataHistory) {
        let newMin: number | null = null;
        let newMax: number | null = null;

        let tempMarkArea: any = {
            itemStyle: {
                color: 'rgba(255, 173, 177, 0.3)'
            },
            data: []
        };
        let startMarkArea: boolean = false;

        for (let i = data.V.length; i--; ) {
            let val = data.V[i];

            if (data.Q) {
                if (data.Q[i] !== 0) {
                    if (!startMarkArea) {
                        if (data.V.length !== i) {
                            tempMarkArea.data.unshift([{}, { xAxis: GetDate(data.T[i + 1]) }]);
                            startMarkArea = true;
                        }
                    }
                } else {
                    if (startMarkArea) {
                        tempMarkArea.data[0][0].xAxis = GetDate(data.T[i + 1]);
                        startMarkArea = false;
                    }
                }
            }

            if (!Number.isNaN(Number(val))) {
                if (newMin === null || Number.isNaN(newMin)) {
                    newMin = val;
                }
                if (newMax === null || Number.isNaN(newMax)) {
                    newMax = val;
                }
            }
            if (newMin != null && newMax != null) {
                if (val > newMax) {
                    newMax = val;
                } else if (val < newMin) {
                    newMin = val;
                }
            }
        }

        let scaleminmax = Math.abs(Number(newMax?.toFixed(3)) - Number(newMin?.toFixed(3)));
        scaleminmax = Number(scaleminmax.toFixed(3));
        if (scaleminmax === 0) {
            scaleminmax = 1;
        } else if (scaleminmax < 0.2) {
            scaleminmax = 0.2;
        }

        let max = '0';
        if (newMax != null) {
            max = Number(newMax + scaleminmax * 0.05).toFixed(3);
        }
        let min = '0';
        if (newMin != null) {
            min = Number(newMin - scaleminmax * 0.05).toFixed(3);
        }

        let penName: any = data.ID.split('/');
        penName = penName[penName.length - 1];

        const foundItem = pens.find((item: { name: any }) => item.name === penName);

        if (foundItem && !foundItem.enable) {
            foundItem.oldMax = max;
            foundItem.oldMin = min;
            max = foundItem.highlimit;
            min = foundItem.lowlimit;
        }

        return { max: max, min: min, enable: foundItem?.enable || false, markArea: tempMarkArea };
    }

    const updateDataParam = async (
        data: IDataHistory[],
        group: number | undefined = undefined,
        Select: string | undefined = undefined
    ) => {
        if (Select == '' || Select == null || '$SELECT' == Select) {
            Select = '';
        }
        Select = Select.toUpperCase();

        window.parent.SubItems(data.map((ele) => ele.ID));

        let newdataobj: any = {};

        if (data) {
            let temparchive = {};
            // let tempHmiHistorySettings: IPens[] = new Array(coloritem.length);
            const tempHmiHistorySettings: IPens[] = HmiHistorySettings
                ? [...HmiHistorySettings]
                : new Array(coloritem.length);
            let tempColor: any[] = [];
            if (HmiHistorySettings !== undefined) {
                HmiHistorySettings.forEach((item) => {
                    (item.name = ''), tempColor.push(item.color);
                });
            }

            let HistorySettings: any = undefined;
            if (group != undefined && group != 0) {
                HistorySettings = hmiclientsdata.GetHistorySettings()[group];
            }

            let activeitem = false;

            let endtimeiso = new Date().toISOString();

            let idlist = 0;

            for (let id2 in data) {
                idlist++;
                let name = data[id2].ID;
                if (name && name != '.') {
                    let lastTime = data[id2].T[data[id2].T.length - 1];

                    if (!archiveTrend) {
                        if (lastTime < Number(endtimeiso)) {
                            let parnew = window.parent.GetParam(name);
                            if (parnew.V != name) {
                                let val = Number(Number(parnew.V).toFixed(3));
                                data[id2].T.push(window.ConvertDateISOtoNs(window.SystemDate()));
                                data[id2].Q?.push(Number(parnew.Q));
                                data[id2].V.push(val);
                            }
                        }
                    }

                    let minMax_markArea = await getMinMax_markArea(data[id2]);

                    let newdata = [];

                    for (let ida = data[id2].V.length; ida--; ) {
                        let val = data[id2].V[ida];
                        if ((config.settings.chart?.xAxis as IAxisSetting)?.type != 'time') {
                            newdata.unshift([data[id2].T[ida], val]);
                        } else {
                            newdata.unshift([GetDate(data[id2].T[ida]), val]);
                        }
                    }

                    let HistSettings = tempHmiHistorySettings.filter((f) => f.name == name)[0];

                    if (HistSettings?.selected != undefined) {
                        // tempHmiHistorySettings[idlist - 1].selected = HistSettings?.selected
                        activeitem = HistSettings?.selected;
                    } else {
                        activeitem = true;
                    }

                    let desc = '';
                    let eudesc = '';
                    HistSettings = CreateItem(idlist, name, desc, eudesc, undefined, 'auto');
                    tempHmiHistorySettings[idlist - 1] = HistSettings;
                    HistSettings.max = minMax_markArea.max;
                    HistSettings.min = minMax_markArea.min;
                    HistSettings.markArea = minMax_markArea.markArea;
                    HistSettings.enable = minMax_markArea.enable;
                    HistSettings.selected = activeitem;

                    if (HistorySettings != null) {
                        if (HistorySettings[idlist - 1].min != null) {
                            HistSettings.min = HistorySettings[idlist - 1].min;
                        }
                        if (HistorySettings[idlist - 1].max != null) {
                            HistSettings.max = HistorySettings[idlist - 1].max;
                        }
                        let enable = HistorySettings[idlist - 1].enable;
                        let step = HistorySettings[idlist - 1].step;
                        HistSettings.enable = enable;
                    }

                    newdataobj[name] = newdata;
                }
            }

            for (let i = 0; i < tempHmiHistorySettings.length; i++) {
                if (!tempHmiHistorySettings[i] || tempHmiHistorySettings[i].name == '') {
                    let active = false;
                    tempHmiHistorySettings[i] = {
                        id: i + 1,
                        color: coloritem[i],
                        curvalue: '',
                        yAxisIndex: undefined,
                        desc: '',
                        eudesc: '',
                        min: 0,
                        max: 100,
                        enable: false,
                        name: '',
                        selected: active,
                        typeLine: 'line',
                        typeScale: 'auto'
                    };
                }

                if (
                    (tempHmiHistorySettings[i].name.indexOf(Select) == 0 && Select != '') ||
                    (!activeitem && Select == '') ||
                    (!activeitem && Select == undefined)
                ) {
                    tempHmiHistorySettings[i].selected = activeitem;
                    activeitem = true;
                }
            }

            const temparchivenew = { ...temparchive, ...newdataobj };

            setArchive(temparchivenew);
            setHmiHistorySettings(tempHmiHistorySettings);
        }
    };

    let CreateItem = function (
        id: number,
        param: string,
        desc: string,
        eudesc: string,
        typeLine: string | undefined,
        typeScale: string,
        colorItem?: string
    ): IPens {
        let item = param.toUpperCase().substr(0, param.lastIndexOf('.'));

        if (item.indexOf('.VALUE') != -1) {
            item = param.toUpperCase().substr(0, item.lastIndexOf('.'));
        }

        let curvalue = Number(window.parent.GetParam(param).V).toFixed(3);

        let tempDesc = '';
        let tempEudesc = '';

        let minmax = 1;
        if (Number(curvalue) > 1) {
            minmax = Number(curvalue) * 2;
        }

        let min = (Number(window.parent.GetParam(param).V) - minmax).toFixed(3);
        let max = (Number(window.parent.GetParam(param).V) + minmax).toFixed(3);
        let index = id;

        let color = coloritem[index - 1];
        if (colorItem !== undefined) {
            color = colorItem;
        }

        let enable = true;
        let yAxisIndex = undefined;

        if (config.tagConfig) {
            if (typeLine == null) {
                typeLine = config.tagConfig[id - 1]?.typeLine || 'line';
            }

            yAxisIndex =
                config.tagConfig[id - 1]?.yAxisIndex != null ? config.tagConfig[id - 1]?.yAxisIndex : yAxisIndex;

            enable = config.tagConfig[id - 1]?.enable;
            if (config.tagConfig[id - 1]?.color !== undefined) {
                color = config.tagConfig[id - 1]?.color;
            }
            tempDesc = config.tagConfig[id - 1]?.desc || '';
            // tempEudesc = config.tagConfig[id - 1].eudesc || '';
        }

        if (tempDesc == '' || tempDesc == null) {
            desc = window.parent.GetParam(item + '.description').V;
            if (desc == '.description' || desc == null || desc == 'null') desc = '';
        } else {
            desc = window.parent.GetParam(tempDesc).V;
        }

        if (tempEudesc !== null) {
            eudesc = window.parent.GetParam(tempEudesc).V;
        }

        if (typeLine == null) {
            typeLine = 'line';
        }
        let tempMarkArea: any = {
            itemStyle: {
                color: 'rgba(255, 173, 177, 0.3)'
            },
            data: []
        };

        let itemalarm: IPens = {
            id: id,
            color: color,
            curvalue: curvalue,
            desc: desc,
            eudesc: eudesc,
            min: min,
            max: max,
            enable: enable,
            name: param,
            // selected: param ? true : false,
            typeLine: typeLine,
            typeScale: typeScale,
            yAxisIndex: yAxisIndex,
            markArea: tempMarkArea
        };
        return itemalarm;
    };

    function GetBlockGroup(name: string) {
        const params = name.split('/');
        return {
            Block: params[0],
            Group: params[1]
        };
    }

    async function SaveGroupPens(obj: any) {
        let pens: any[] = [];

        for (let Key in obj.blocks) {
            let TagName: string = '';
            let PARAM: string = '';
            let DATA: string = '';

            if (obj.blocks[Key].bindinglist) {
                obj.blocks[Key].bindinglist.map((item: any, index: number) => {
                    if (item.name == 'TAG') {
                        TagName = item.Value == 'TAG' ? '' : item.Value;
                    }
                    if (item.name == 'PARAM') {
                        PARAM = item.Value == 'PARAM' ? '' : item.Value;
                    }
                    if (item.name == 'DATA') {
                        DATA = item.Value == 'DATA' ? '' : item.Value;
                    }
                });
            }

            if (TagName != undefined && TagName != null) {
                let lowlimit = obj.blocks[Key].parameters.LOWLIMIT.CV;
                let lowlimitPath = obj.blocks[Key].parameters.LOWLIMIT.path;
                let highlimit = obj.blocks[Key].parameters.HIGHLIMIT.CV;
                let highlimitPath = obj.blocks[Key].parameters.HIGHLIMIT.path;

                let enable =
                    obj.blocks[Key].parameters.HIGHLIMIT.sourceIn.Enable &&
                    obj.blocks[Key].parameters.LOWLIMIT.sourceIn.Enable;

                pens.push({
                    name: TagName ? `${TagName}.${PARAM}` : '',
                    lowlimit: lowlimit,
                    lowlimitPath: lowlimitPath,
                    highlimit: highlimit,
                    highlimitPath: highlimitPath,
                    enable: enable,
                    TAG: TagName,
                    PARAM: PARAM,
                    DATA: DATA,
                    penPath: obj.blocks[Key].path,
                    penID: obj.blocks[Key].id
                });
            }
        }

        return pens;
    }

    async function fetchPenData(penPath: string) {
        try {
            const response = await fetch(window.hostdata + `/Base/GetObject?path=${penPath}`);
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Ошибка при получении данных:', error);
            return null;
        }
    }

    const ReadHistoryData = async function (Items: string[]) {
        // let endtimeiso = new Date().toISOString();
        let endtimeiso = xStart;

        // const CurrentTime = new Date();
        const CurrentTime = new Date(endtimeiso);

        let hours = trendTime.recordTime;

        CurrentTime.setHours(CurrentTime.getHours() - hours);
        let starttimeiso = CurrentTime.toISOString();

        let funcName: string[] = [];
        Items.forEach((element) => funcName.push('INTERPOLATIVE'));

        let maxPoint = 7200;
        let countPoint = maxPoint;

        let deltaNs = (new Date(endtimeiso).getTime() - new Date(starttimeiso).getTime()) * 1000000;

        let intervalNs = Math.floor(deltaNs / countPoint);

        return ReadProcessed(Items, funcName, starttimeiso, endtimeiso, intervalNs);
    };

    const [data, setData] = React.useState<any[]>();
    const [groupPensInfo, setgroupPensInfo] = React.useState<any[]>();

    function TestData(dataNames: any) {
        let updatedArray = dataNames.map((item: string) => item.replace('.PV', ''));
        setData(updatedArray);
        setgroupPensInfo(pens);
    }

    function UpdateArchiveItems(param: string[]) {
        setArchive({});
        let arraySelectPen: string[] = [];

        ReadHistoryData(param).then(async (data: any) => {
            if (data) {
                if (data.length == 0) {
                    for (let item of pens) {
                        if (!item.name) continue;
                        let pen = {
                            ID: `${item.DATA}/${item.name}`,
                            Q: [],
                            V: [],
                            T: []
                        };

                        data.push(pen);
                    }
                }

                arraySelectPen = data.map((item: { ID: any }) => item.ID);

                setSelectedPen((prevState) => {
                    if (prevState == '') {
                        return arraySelectPen[0];
                    } else if (!arraySelectPen.includes(prevState)) {
                        return arraySelectPen[0];
                    }
                    return prevState;
                });

                updateDataParam(data);

                TestData(arraySelectPen);
            }
        });
    }

    const UpdateEnableState = (id: number, state: boolean) => {
        if (HmiHistorySettings) {
            const tempHmiHistory = HmiHistorySettings.slice();
            tempHmiHistory[id - 1].selected = state;
            setHmiHistorySettings(tempHmiHistory);
        }
    };

    const ChangeItem = (e: any, id: number) => {
        setPenEdit(id);

        console.log(id);

        e.preventDefault();
    };

    const [playStopDisplay, setPlayStopDisplay] = React.useState(false);
    const [newSeriesPoints, setNewSeriesPoints] = React.useState<any[]>([]);

    const handleChartRef = (ref: any) => {
        // ChartRef.current = ref;
    };

    function StartStopInterval(check: boolean) {
        setPlayStopDisplay(check);
    }

    function callbackClickRow(name: string) {
        setSelectedPen(name);
    }

    async function handleToggleChange(newItem: any, enable: boolean) {
        if (HmiHistorySettings && groupPensInfo) {
            const tempHmiHistory = HmiHistorySettings.slice();
            const TempItem = tempHmiHistory.find((item) => item.name == newItem.name);

            const penInfo = groupPensInfo.find((item: { name: any }) => {
                return item.name && newItem.name.includes(item.name);
            });

            if (TempItem && penInfo) {
                TempItem.enable = enable;
                let max = penInfo.highlimit;
                let min = penInfo.lowlimit;

                if (enable && TempItem.curvalue) {
                    max = penInfo.oldMax;
                    min = penInfo.oldMin;
                } else {
                    penInfo.oldMin = TempItem.min;
                    penInfo.oldMax = TempItem.max;
                }

                TempItem.max = max;
                TempItem.min = min;

                sendParametersToUpdate(penInfo, enable);
                setHmiHistorySettings(tempHmiHistory);
                setgroupPensInfo(groupPensInfo);
            }
        }
    }

    function sendParametersToUpdate(penInfo: any, enable: boolean) {
        const PensToSend: any[] = [];

        PensToSend.push(
            {
                item: `${penInfo.highlimitPath}.SOURCEIN.Enable`,
                value: `${enable}`
            },
            {
                item: `${penInfo.lowlimitPath}.SOURCEIN.Enable`,
                value: `${enable}`
            }
        );

        hmiclientbasedata.SetParamBaseCentum(PensToSend);
    }

    const UpdateMinMax = (id: number, value: string, param: 'min' | 'max') => {
        const updateHmiHistory = () => {
            if (HmiHistorySettings && groupPensInfo) {
                const tempHmiHistory = HmiHistorySettings.slice();
                const tempgroupPensInfo = groupPensInfo.slice();
                const TempItem = tempHmiHistory.find((item) => item.id === id);
                if (TempItem) {
                    TempItem[param] = value;
                    setHmiHistorySettings(tempHmiHistory);
                }

                const path = param === 'min' ? 'lowlimit' : 'highlimit';
                tempgroupPensInfo[id - 1][path] = value;
                setgroupPensInfo(tempgroupPensInfo);
            }
        };

        if (groupPensInfo) {
            const penInfo = groupPensInfo[id - 1];
            const path = param === 'min' ? penInfo.lowlimitPath : penInfo.highlimitPath;

            hmiclientbasedata.SetParamBaseCentum([{ item: path, value }]);
            updateHmiHistory();
        }
    };

    function updatePenProperties(id: number, values: { [key: string]: string }) {
        if (groupPensInfo && PenEditElement) {
            return hmiclientbase
                .SettingsGetObjectDto(groupPensInfo[id].penID)
                .then((data) => {
                    const promises = data.bindinglist.map((item: any) => {
                        const value = values[item.name];
                        if (value !== undefined) {
                            return hmiclientbasedata.SettingsChangeProperty(item.id, 'Value', value);
                        }
                        return Promise.resolve();
                    });

                    return Promise.all(promises);
                })
                .then(() => {
                    setResetData(!resetData);
                })
                .catch((error) => {
                    console.error('Ошибка при обновлении данных пера:', error);
                });
        }
    }

    function updateDate(id: string, propName: string, value: any) {
        if (value != '') {
            hmiclientbase.SettingsChangeProperty(id, propName, value).then((rez: any) => {
                if (rez === 'true') {
                    setResetData(!resetData);
                }
            });
        }
    }

    function SaveNewPen(id: number) {
        updatePenProperties(id, {
            DATA: `${PenEditElement.DATA}`,
            TAG: `${PenEditElement.TAG}`,
            PARAM: `${PenEditElement.PARAM}`
        });
    }

    function deletePen(id: number) {
        updatePenProperties(id, {
            DATA: ``,
            TAG: ``,
            PARAM: ``
        });
    }

    function SelectNewGroup(group: any) {
        const newBlockGroup = group.path.replace(`${trendsPath}/`, '');
        if (newBlockGroup != currentBlockGroup) {
            setHmiHistorySettings(undefined);
            setCurrentBlockGroup(newBlockGroup);
        }
    }

    const updateXStart = (prevState: string, direction: 'forward' | 'backward', hours: number): string => {
        const currentDate = new Date(prevState);
        const updatedDate = new Date(
            currentDate.setHours(
                direction === 'forward' ? currentDate.getHours() + hours : currentDate.getHours() - hours
            )
        );

        const now = new Date();

        return direction === 'forward' && updatedDate > now ? now.toISOString() : updatedDate.toISOString();
    };

    function ResetDataZoom() {
        const chartInstanse = refs.chartRef.current.getEchartsInstance();
        chartInstanse.dispatchAction({
            type: 'dataZoom',
            start: 80,
            end: 100,
            dataZoomIndex: 1
        });
    }

    if (HmiHistorySettings) {
        return (
            <>
                {penEdit !== -1 && (
                    <Modal
                        foot={{
                            buttons: [
                                {
                                    size: 'small',
                                    text: 'Сохранить',
                                    onClick() {
                                        SaveNewPen(penEdit - 1);
                                        setPenEdit(-1);
                                    }
                                },
                                {
                                    size: 'small',
                                    text: 'Отменить',
                                    styleType: 'tinted',
                                    onClick() {
                                        setPenEdit(-1);
                                    }
                                }
                            ],
                            terminalBlock: true
                        }}
                        width={'30%'}
                        onCloseClick={() => {
                            setPenEdit(-1);
                        }}>
                        <PenEdit
                            pen={HmiHistorySettings ? HmiHistorySettings[penEdit - 1] : ''}
                            path={`${config.settings.chart.Path}`}
                            penFromGroup={groupPensInfo ? groupPensInfo[penEdit - 1] : {}}
                            setPenEditElement={(item) => {
                                setPenEditElement(item);
                            }}
                        />
                    </Modal>
                )}
                <div className={styles.mainContainer}>
                    {visibleTrendGroup && (
                        <div className={styles.trendGroupContainer}>
                            <span className={styles.headerGroup}>Группы трендов</span>
                            <Search
                                data={comboBoxData}
                                // selected={comboBoxData[0].id}
                                type={'search'}
                                onClick={(event: SearchData) => {
                                    SelectNewGroup(event.item);
                                }}
                                placeholder="Поиск"
                                onEnter={(event: SearchData) => {
                                    SelectNewGroup(event.item);
                                }}
                                width="100%"
                            />
                            <div className={styles.groupsContainer}>
                                {BlockGroups.map((item: any, index: number) => {
                                    const desc = item.description;
                                    const name = item.name;
                                    return (
                                        <span
                                            className={styles.groupElement}
                                            style={{ fontWeight: trendInfo.name == name ? 600 : 400 }}
                                            key={`group-${index}`}
                                            title={name}
                                            onClick={() => {
                                                SelectNewGroup(item);
                                            }}>
                                            {index + 1}: {desc && desc != '' ? desc : name}
                                        </span>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    <div
                        className={styles.trendContainer}
                        style={{ width: visibleTrendGroup ? 'calc(100% - 220px)' : '100%' }}>
                        <div className={styles.butContainer}>
                            <div className={styles.leftContent}>
                                {isEditingDesc ? (
                                    <Input
                                        type="text"
                                        width={'auto'}
                                        defaultValue={trendInfo.description}
                                        onBlur={(event) => {
                                            updateDate(trendInfo.id, 'description', event.target.value);
                                            setIsEditingDesc(false);
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter') {
                                                event.currentTarget.blur();
                                            }
                                        }}
                                    />
                                ) : (
                                    <span
                                        className={styles.groupElement}
                                        onDoubleClick={() => setIsEditingDesc(true)}
                                        style={{ cursor: 'pointer', fontWeight: 500, fontSize: '18px' }}>
                                        {trendInfo.description || trendInfo.name}
                                    </span>
                                )}
                            </div>
                            <div className={styles.rightContent}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span className={styles.groupElement} style={{ fontSize: '14px' }}>
                                        Recod Time:
                                    </span>
                                    <div style={{ width: '30px' }}>
                                        <Input
                                            type="text"
                                            width="30px"
                                            defaultValue={trendInfo.recordTime}
                                            onBlur={(e) => {
                                                updateDate(
                                                    trendInfo.blockObj.parameters.RECORDTIME.id,
                                                    'CV',
                                                    e.target.value
                                                );
                                            }}
                                            onKeyDown={(event) => {
                                                if (event.key === 'Enter') {
                                                    event.currentTarget.blur();
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                {visibleTrendGroup ? (
                                    <IconButton
                                        title="Скрыть группу трендов"
                                        onClick={() => {
                                            setVisibleTrendGroup(false);
                                        }}
                                        imageUrl={'HideOff'}
                                    />
                                ) : (
                                    <IconButton
                                        title="Раскрыть группу трендов"
                                        onClick={() => {
                                            setVisibleTrendGroup(true);
                                        }}
                                        imageUrl={'HideOn'}
                                    />
                                )}
                                <button
                                    title={'Смещение времени оси X назад'}
                                    onClick={() => {
                                        setHmiHistorySettings(undefined);
                                        setXStart((prevState) =>
                                            updateXStart(prevState, 'backward', trendInfo.recordTime)
                                        );
                                        ResetDataZoom();
                                    }}>
                                    {IconLeft}
                                </button>
                                <button
                                    title={'Смещение времени оси X вперед'}
                                    onClick={() => {
                                        setHmiHistorySettings(undefined);
                                        setXStart((prevState) =>
                                            updateXStart(prevState, 'forward', trendInfo.recordTime)
                                        );
                                        ResetDataZoom();
                                    }}>
                                    {IconRight}
                                </button>
                            </div>
                        </div>
                        <div className={styles.trendGraph}>
                            <GroupGraph
                                refs={refs}
                                data={archive}
                                selectedPen={selectedPen}
                                pens={HmiHistorySettings}
                                groupPensInfo={groupPensInfo}
                                parentID={'props.parentID'}
                                config={config}
                                playStopDisplay={playStopDisplay}
                                newSeriesPoints={newSeriesPoints}
                                onChartRef={handleChartRef}
                                SetInterval={StartStopInterval}
                                resetData={resetData}
                            />
                        </div>
                        <div className={styles.trendTable}>
                            <GroupTable
                                items={HmiHistorySettings}
                                calbackEditItem={ChangeItem}
                                UpdateEnableState={UpdateEnableState}
                                UpdateMinMax={UpdateMinMax}
                                callbackClickRow={callbackClickRow}
                                handleToggleChange={handleToggleChange}
                                deletePen={deletePen}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    } else {
        return <LoadPage visible={true} />;
    }
}

export default index;

interface IPenEdit {
    pen: IPens | string;
    path: string;
    penFromGroup: any;
    setPenEditElement: (item: any) => void;
}

interface SelectedElem {
    id: string;
    value: string;
}

function PenEdit(props: IPenEdit) {
    const { pen, path, penFromGroup } = props;

    const [Element, setElement] = useState({
        TAG: penFromGroup.TAG,
        PARAM: penFromGroup.PARAM,
        DATA: penFromGroup.DATA
    });

    const [paths, setPaths] = useState<IComboBoxData[]>([]);
    const [params, setParams] = useState<IComboBoxData[]>([]);

    const [pathParameters, setPathsParameters] = useState<{ [key: string]: string[] }>();

    const [selectedPath, setSelectedPath] = useState<SelectedElem>({ id: '0', value: '' });
    const [selectedParam, setSelectedParam] = useState<SelectedElem>({ id: '0', value: '' });

    useEffect(() => {
        hmiclientbasedata
            .SettingsGetPathsType('iXyberBaseLib.Parameter')
            .then((items) => {
                const newItems = items.filter((item: string) => {
                    return !item.includes('TEMPLATES');
                });

                return newItems;
            })
            .then((items) => {
                const Params: { [key: string]: string[] } = {};

                let uniqueItems = items.map((item: string) => {
                    const path = item.split('.')[0];
                    const param = item.split('.')[1];

                    if (Params[path]) {
                        Params[path].push(param);
                    } else {
                        Params[path] = [param];
                    }

                    return path;
                });

                uniqueItems = [...new Set(uniqueItems)];

                const valueMap = new Map(
                    uniqueItems.map((item: string, index: number) => [item, { id: index, value: item }])
                );

                const foundPath = penFromGroup.DATA !== '' ? `${penFromGroup.DATA}/${penFromGroup.TAG}` : path;
                const foundItem = valueMap.get(foundPath);

                if (foundItem && typeof foundItem === 'object' && 'id' in foundItem && 'value' in foundItem) {
                    setSelectedPath(foundItem as SelectedElem);
                    const params = Params[foundItem.value as string];
                    const foundIndex = params.findIndex((item) => item === penFromGroup.PARAM);

                    if (foundIndex !== -1) {
                        const foundElement = { id: String(foundIndex), value: params[foundIndex] };
                        setSelectedParam(foundElement);
                    }

                    initPen(Params, foundItem as SelectedElem);
                } else {
                    console.error('Invalid foundItem:', foundItem);
                }

                const newArr: IComboBoxData[] = uniqueItems.map((item: string, index: number) => {
                    return { id: index, value: item };
                });

                setPaths(newArr);
                setPathsParameters(Params);
            });
    }, []);

    function initPen(pathParams: { [key: string]: string[] }, selectedPath: SelectedElem) {
        if (pathParams && selectedPath?.value) {
            let param;
            const params: IComboBoxData[] = pathParams[selectedPath?.value].map((item: string, index: number) => {
                if (penFromGroup.PARAM && penFromGroup.PARAM == item) {
                    param = item;
                }
                return { id: index.toString(), value: item };
            });

            const pathArr = selectedPath.value.split('/');
            const DATA = pathArr.slice(0, -1).join('/');
            const TAG = pathArr[pathArr.length - 1];

            setElement({ ...Element, DATA: DATA, TAG: TAG, PARAM: param ? param : params[0].value });
            setParams(params);
        }
    }

    function setNewPen(item: SelectedElem) {
        if (pathParameters && item?.value) {
            const params: IComboBoxData[] = pathParameters[item?.value].map((item: string, index: number) => {
                return { id: index.toString(), value: item };
            });

            const pathArr = item.value.split('/');
            const DATA = pathArr.slice(0, -1).join('/');
            const TAG = pathArr[pathArr.length - 1];

            setElement({ ...Element, DATA: DATA, TAG: TAG, PARAM: params[0].value });
            setParams(params);
        }
    }

    useEffect(() => {
        props.setPenEditElement(Element);
    }, [Element]);

    return (
        <div style={{ width: '550px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ width: '80px' }}>Путь:</span>
                <ComboBox
                    data={paths}
                    onClick={(item) => {
                        setSelectedPath(item);
                        setNewPen(item);
                    }}
                    onEnter={() => {}}
                    selected={selectedPath?.id || '0'}
                    width="400px"
                    placeholder="Задайте путь"
                />
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ width: '80px' }}>Параметр:</span>
                <ComboBox
                    data={params}
                    onClick={(item) => {
                        setSelectedParam(item);
                        setElement({ ...Element, PARAM: item.value });
                    }}
                    onEnter={() => {}}
                    selected={selectedParam?.id || '0'}
                    width="400px"
                    placeholder="Задайте параметр"
                />
            </div>
        </div>
    );
}
